// MII World Map — flat Mercator canvas with animated sourcing routes
(function() {
  var canvas = document.getElementById('mii-world-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0;

  // ── Simplified coastlines [lat, lon] (low-poly, enough to be recognisable) ──
  var COASTS = [
    // Africa
    [[37,-6],[35,10],[30,32],[20,37],[12,43],[12,51],[0,42],[-4,40],
     [-12,40],[-26,33],[-34,27],[-34,18],[-28,17],[-18,12],[-5,9],
     [4,3],[5,-2],[5,-9],[10,-17],[15,-17],[20,-16],[25,-15],[30,-10],[37,-6]],

    // Europe
    [[70,26],[60,30],[55,22],[55,14],[50,16],[45,14],[43,17],[40,18],
     [36,28],[37,23],[37,10],[43,5],[43,-1],[43,-9],[38,-9],[36,-5],
     [36,3],[44,2],[43,6],[47,8],[48,17],[52,20],[55,24],[57,20],
     [60,25],[65,28],[70,26]],

    // Asia (without Indian peninsula — drawn separately)
    [[70,26],[70,60],[72,100],[70,140],[60,141],[42,141],[35,136],
     [30,122],[25,122],[22,114],[10,105],[1,104],[3,115],[10,105],
     [15,110],[20,110],[20,93],[22,90],[20,86],[15,80],[8,77],
     [10,76],[12,74],[20,66],[24,68],[22,60],[24,57],[22,58],
     [15,52],[12,44],[37,36],[40,27],[40,18],[43,17],[45,14],
     [48,16],[55,22],[60,30],[70,26]],

    // North America
    [[70,-141],[60,-137],[50,-124],[37,-122],[32,-117],[23,-110],
     [15,-91],[9,-79],[10,-74],[14,-83],[20,-87],[22,-90],[14,-83],
     [9,-79],[10,-62],[18,-66],[25,-80],[30,-80],[35,-75],[42,-70],
     [47,-53],[53,-56],[60,-64],[68,-82],[70,-141]],

    // South America
    [[11,-73],[10,-62],[8,-60],[5,-60],[1,-50],[-5,-35],[-12,-37],
     [-22,-42],[-34,-52],[-55,-67],[-55,-65],[-52,-58],[-46,-66],
     [-38,-57],[-34,-56],[-23,-43],[-5,-35],[-2,-40],[5,-60],[11,-73]],

    // Australia
    [[-14,132],[-14,128],[-22,114],[-30,115],[-34,118],
     [-37,140],[-38,146],[-32,152],[-25,153],[-14,135],[-14,132]]
  ];

  // India — drawn separately with a faint gold fill
  var INDIA_COAST = [
    [28,72],[24,68],[20,66],[12,74],[8,77],[8,79],[10,80],[13,80],
    [15,80],[20,87],[22,90],[20,86],[20,80],[24,78],[28,72]
  ];

  // Source cities [lat, lon, label, align]
  var CITIES = [
    [51.5, -0.1,   'LDN', 'center'],
    [40.7, -74.0,  'NYC', 'center'],
    [25.2,  55.3,  'DXB', 'center'],
    [ 1.3, 103.8,  'SGP', 'center'],
    [35.7, 139.7,  'TYO', 'center']
  ];

  var INDIA_LAT = 20.6, INDIA_LON = 78.9;

  // Mercator projection
  function proj(lat, lon) {
    return [(lon + 180) / 360 * W, (90 - lat) / 180 * H];
  }

  // Quadratic bezier point
  function bz(p0, cp, p1, t) {
    var mt = 1 - t;
    return [mt*mt*p0[0] + 2*mt*t*cp[0] + t*t*p1[0],
            mt*mt*p0[1] + 2*mt*t*cp[1] + t*t*p1[1]];
  }

  // Get curve control point (arcs toward north = upward in Mercator)
  function ctrlPt(from, to) {
    var mx = (from[0] + to[0]) / 2;
    var my = (from[1] + to[1]) / 2;
    var dx = Math.abs(to[0] - from[0]);
    return [mx, my - dx * 0.38];
  }

  // Build particles — two per route, offset start positions
  var particles = [];
  CITIES.forEach(function(c, i) {
    particles.push({ ci: i, t: i * 0.2,       spd: 0.0028 + i * 0.0004, r: 2.2, a: 0.85 });
    particles.push({ ci: i, t: i * 0.2 + 0.5, spd: 0.0022 + i * 0.0003, r: 1.8, a: 0.50 });
  });

  function resize() {
    var rect = canvas.parentElement.getBoundingClientRect();
    W = Math.round(rect.width);
    H = Math.round(rect.height);
    canvas.width  = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function drawCoasts() {
    // All landmasses
    COASTS.forEach(function(coast) {
      ctx.beginPath();
      var p0 = proj(coast[0][0], coast[0][1]);
      ctx.moveTo(p0[0], p0[1]);
      for (var i = 1; i < coast.length; i++) {
        var p = proj(coast[i][0], coast[i][1]);
        ctx.lineTo(p[0], p[1]);
      }
      ctx.closePath();
      ctx.fillStyle   = 'rgba(255,255,255,0.04)';
      ctx.strokeStyle = 'rgba(255,255,255,0.18)';
      ctx.lineWidth   = 0.7;
      ctx.fill();
      ctx.stroke();
    });

    // India — gold tint fill
    ctx.beginPath();
    var ip0 = proj(INDIA_COAST[0][0], INDIA_COAST[0][1]);
    ctx.moveTo(ip0[0], ip0[1]);
    INDIA_COAST.slice(1).forEach(function(pt) {
      var p = proj(pt[0], pt[1]);
      ctx.lineTo(p[0], p[1]);
    });
    ctx.closePath();
    ctx.fillStyle   = 'rgba(201,168,76,0.14)';
    ctx.strokeStyle = 'rgba(201,168,76,0.45)';
    ctx.lineWidth   = 1.0;
    ctx.fill();
    ctx.stroke();
  }

  function drawGrid() {
    ctx.strokeStyle = 'rgba(255,255,255,0.035)';
    ctx.lineWidth   = 0.5;
    ctx.setLineDash([3, 6]);
    // Longitude lines every 30°
    [-150,-120,-90,-60,-30,0,30,60,90,120,150].forEach(function(lon) {
      ctx.beginPath();
      var p = proj(85, lon); ctx.moveTo(p[0], p[1]);
      p = proj(-85, lon);    ctx.lineTo(p[0], p[1]);
      ctx.stroke();
    });
    // Latitude lines
    [-60,-30,0,30,60].forEach(function(lat) {
      ctx.beginPath();
      var p = proj(lat, -180); ctx.moveTo(p[0], p[1]);
      p = proj(lat, 180);      ctx.lineTo(p[0], p[1]);
      ctx.stroke();
    });
    ctx.setLineDash([]);
  }

  function drawRoutes() {
    var dest = proj(INDIA_LAT, INDIA_LON);
    CITIES.forEach(function(c) {
      var from = proj(c[0], c[1]);
      var cp   = ctrlPt(from, dest);
      ctx.beginPath();
      ctx.moveTo(from[0], from[1]);
      ctx.quadraticCurveTo(cp[0], cp[1], dest[0], dest[1]);
      ctx.strokeStyle = 'rgba(201,168,76,0.20)';
      ctx.lineWidth   = 1;
      ctx.setLineDash([4, 6]);
      ctx.stroke();
      ctx.setLineDash([]);
    });
  }

  function drawCities() {
    var dest = proj(INDIA_LAT, INDIA_LON);

    // Source city dots only — no labels
    CITIES.forEach(function(c) {
      var p = proj(c[0], c[1]);
      // Soft glow
      var g = ctx.createRadialGradient(p[0],p[1],0, p[0],p[1],7);
      g.addColorStop(0, 'rgba(255,255,255,0.14)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.beginPath(); ctx.arc(p[0], p[1], 7, 0, Math.PI*2);
      ctx.fillStyle = g; ctx.fill();
      // Dot
      ctx.beginPath(); ctx.arc(p[0], p[1], 2.5, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(255,255,255,0.50)'; ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.22)'; ctx.lineWidth = 1; ctx.stroke();
    });

    // India destination — pulsing gold ring
    var pulse = (Math.sin(Date.now() * 0.0016) + 1) / 2;
    var outerR = 8 + pulse * 5;
    var g2 = ctx.createRadialGradient(dest[0],dest[1],0, dest[0],dest[1],outerR);
    g2.addColorStop(0, 'rgba(201,168,76,0.35)');
    g2.addColorStop(1, 'rgba(201,168,76,0)');
    ctx.beginPath(); ctx.arc(dest[0], dest[1], outerR, 0, Math.PI*2);
    ctx.fillStyle = g2; ctx.fill();

    ctx.beginPath(); ctx.arc(dest[0], dest[1], 4.5, 0, Math.PI*2);
    ctx.fillStyle   = 'rgba(201,168,76,0.30)'; ctx.fill();
    ctx.strokeStyle = 'rgba(201,168,76,0.80)'; ctx.lineWidth = 1.5; ctx.stroke();

    ctx.fillStyle = 'rgba(201,168,76,0.75)';
    ctx.font = 'bold 9px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('IN', dest[0], dest[1] + 16);
  }

  function drawParticles() {
    var dest = proj(INDIA_LAT, INDIA_LON);
    particles.forEach(function(p) {
      p.t = (p.t + p.spd) % 1;
      var c    = CITIES[p.ci];
      var from = proj(c[0], c[1]);
      var cp   = ctrlPt(from, dest);
      var pos  = bz(from, cp, dest, p.t);
      ctx.beginPath();
      ctx.arc(pos[0], pos[1], p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(201,168,76,' + p.a + ')';
      ctx.fill();
    });
  }

  var visible = false;
  function frame() {
    requestAnimationFrame(frame);
    if (!visible) return;
    ctx.clearRect(0, 0, W, H);
    drawGrid();
    drawCoasts();
    drawRoutes();
    drawParticles();
    drawCities();
  }

  // Fade in after a brief delay
  setTimeout(function() {
    visible = true;
    canvas.style.opacity = '1';
  }, 300);

  resize();
  var ro = window.ResizeObserver ? new ResizeObserver(function() {
    ctx.setTransform(1,0,0,1,0,0);
    resize();
  }) : null;
  if (ro) ro.observe(canvas.parentElement);
  else window.addEventListener('resize', function() { ctx.setTransform(1,0,0,1,0,0); resize(); });

  frame();
})();
